import "liquid-fire/velocity-ext";

export default {
  name: 'liquid-fire',
  initialize: function() {}
};
